import { Component, OnInit, input } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'mutara-stepper-header',
  templateUrl: './stepper-header.component.html',
  styleUrls: ['./stepper-header.component.scss'],
  standalone: false
})
export class StepperHeaderComponent extends FieldType {
  index = input<number | undefined>(undefined);
  stepLabel = input<string>("Current Step");
  nextStepLabel = input<string>("Next Step");
  canMove = input<boolean>(true);
  isFixed = input<boolean>(false);
  stepCount = input<number | undefined>(undefined);

  constructor() {
    super();
  }

}